import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";
import { focusVisibleSx } from "@3sc/common-component";
import { useTranslation } from "react-i18next";
import images from "../../constant/images";
import { FONT } from "./authStyles";

/* Shared "Back to login" control for the NewLogin auth screens.
 * Extracted so ForgotPasswordPage / EmailSentPage share one definition
 * instead of duplicating the markup (SonarQube duplication). */
const BackToLogin = ({ onBackToLogin }) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing="0.667rem"
      component="button"
      onClick={onBackToLogin}
      sx={{
        background: "none",
        border: "none",
        cursor: "pointer",
        p: 0,
        width: "fit-content",
        mx: "auto",
        outline: "none",
        "&:hover .back-label": { textDecoration: "underline" },
        ...focusVisibleSx(),
      }}
    >
      <Typography
        className="back-label"
        sx={{
          fontFamily: FONT,
          fontSize: "0.852rem",
          fontWeight: 300,
          lineHeight: "1.238rem",
          color: "rgba(7, 8, 11, 0.7)",
        }}
      >
        {t("Back_to_login")}
      </Typography>
      {/* Circular back-arrow icon */}
      <Box sx={{ position: "relative", width: "1.905rem", height: "1.55rem" }}>
        <Box component="img" src={images.BackArrow} />
      </Box>
    </Stack>
  );
};

BackToLogin.propTypes = {
  onBackToLogin: PropTypes.func,
};

export default BackToLogin;
